// extracted by mini-css-extract-plugin
export default {"video":"head_video__2sPs6","head":"head_head__d7hZg","info":"head_info__Ugm9C","second":"head_second__Ei9-k","scroll":"head_scroll__q65Oh"};